// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './tenants-api';

export const useListTenants: typeof hookExports.useListTenants = hookExports.useListTenants;
export const useLazyListTenants: typeof hookExports.useLazyListTenants =
  hookExports.useLazyListTenants;
export const useGetTenant: typeof hookExports.useGetTenant = hookExports.useGetTenant;
export const useLazyGetTenant: typeof hookExports.useLazyGetTenant = hookExports.useLazyGetTenant;
export const useCreateTenant: typeof hookExports.useCreateTenant = hookExports.useCreateTenant;
export const useUpdateTenant: typeof hookExports.useUpdateTenant = hookExports.useUpdateTenant;
export const useDeleteTenant: typeof hookExports.useDeleteTenant = hookExports.useDeleteTenant;
export const useListTenantMembers: typeof hookExports.useListTenantMembers =
  hookExports.useListTenantMembers;
export const useLazyListTenantMembers: typeof hookExports.useLazyListTenantMembers =
  hookExports.useLazyListTenantMembers;
export const useAddTenantMember: typeof hookExports.useAddTenantMember =
  hookExports.useAddTenantMember;
export const useGetTenantMember: typeof hookExports.useGetTenantMember =
  hookExports.useGetTenantMember;
export const useLazyGetTenantMember: typeof hookExports.useLazyGetTenantMember =
  hookExports.useLazyGetTenantMember;
export const useDeleteTenantMember: typeof hookExports.useDeleteTenantMember =
  hookExports.useDeleteTenantMember;
export const useUpdateTenantMembership: typeof hookExports.useUpdateTenantMembership =
  hookExports.useUpdateTenantMembership;
export const useDeleteTenantMembership: typeof hookExports.useDeleteTenantMembership =
  hookExports.useDeleteTenantMembership;
